// extracted by mini-css-extract-plugin
export default {"textXs":"textXS_textXs__+8OrF"};